import React from 'react';
import classNames from 'classnames';

import Logo from 'layouts/header/Logo';

import classes from './index.module.css';


const HeaderLogoOnly = () => {
  return (
    <nav className={classNames('navbar p-0', classes.navbar)}>
      <div
        className={classNames(
          'container d-flex justify-content-between flex-nowrap',
          classes.container
        )}
      >
        <div className="d-flex align-items-center">
          <Logo noLinks />
        </div>
      </div>
    </nav>
  );
};

export default HeaderLogoOnly;
